import React, { useEffect, useMemo, useState } from "react";
import AdminUserService from "../../../services/adminUserServices";
import { Column, useTable } from "react-table";
import ReactModal from "react-modal";
import ButtonWithIcon from "../../../components/StyledComp/ButtonWithIcon";
import {
  Button,
  Label,
  PageLink,
} from "../../../components/StyledComp/StyledComp";
import { useForm } from "react-hook-form";
import "../../../Styles/CommonStyles.scss";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useAppSelector } from "../../../store/hooks";

interface AddFormValue {
  CostName: string | null;
  Status: string | null;
}

const Cost: React.FC = () => {
  const [costList, setCostList] = useState<any[] | undefined>([]);
  const [dialogTitle, setdialogTitle] = useState<string>("Add CostName");
  const [Id, setId] = useState<number>(0);
  const [addCostDialog, setaddCostDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any | undefined>();
  const [isEdit, setisEdit] = useState<boolean>(false);
  const form = useForm<AddFormValue>();
  const { register, control, handleSubmit, formState, setValue, reset } = form;
  const { errors } = formState;
  const roleCapabilites = useAppSelector(
    (state) => state.user.roleCapabilities
  );

  const getCost = async () => {
    const response = await AdminUserService.getCost();
    console.log(response);
    if (response.data.data != null) {
      setCostList(response.data.data);
    } else {
      alert(response.data.errors[0]);
    }
  };
  useEffect(() => {
    getCost();
  }, []);

  const handleEdit = (rowData: any) => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("settings.edit")
      )
    ) {
      alert("No Access");
      return;
    }
    setisEdit(true);
    setSelectedRow(rowData);
    reset();

    setValue("CostName", rowData.CostName);
    setValue("Status", rowData.Status);

    setId(rowData.Id);
    setdialogTitle("Update Cost");
    setaddCostDialog(true);
  };

  const columns = React.useMemo<Column<any>[]>(
    () => [
      { id: "Id", Header: "ID", accessor: "Id" },
      { id: "CostName", Header: "Cost Name", accessor: "CostName" },
      {
        id: "Status",
        Header: "Status ID",
        accessor: "Status",

        Cell: ({ value }: { value: number }) => (
          <span>{value === 1 ? "Active" : "Inactive"}</span>
        ),
      },
      {
        id: "edit",
        Header: "Action",
        accessor: (row: any) => (
          <a
            className="d-flex editRow justify-content-center"
            onClick={() => handleEdit(row)}
          >
            <EditIcon></EditIcon>
          </a>
        ),
      },
    ],
    []
  );
  const data = useMemo(() => costList, [costList])!;

  const TableInstance = useTable({
    columns,
    data,
  });

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    TableInstance;
  let index = 0;

  const openDialog = () => {
    if (
      !roleCapabilites.some((obj: any) =>
        Object.values(obj).includes("settings.create")
      )
    ) {
      alert("No Access");
      return;
    }
    setisEdit(false);
    setValue("CostName", "");
    setdialogTitle("Add Cost ");
    setaddCostDialog(true);
  };

  const handleClose = () => {
    reset();
    setaddCostDialog(false);
  };
  const addCost = async (data: any) => {
    const response = await AdminUserService.addCost(data);
    console.log(response);
    if (response.data.data != null) {
      getCost();
      setaddCostDialog(false);
      alert("Cost Added Successfully");
    } else {
      alert(response.data.errors[0]);
    }
  };

  const updateCost = async (data: any) => {
    const response = await AdminUserService.updateCost(data);
    console.log(response);
    if (response.data.data != null) {
      getCost();
      setaddCostDialog(false);
      alert("Cost updated Successfully");
    } else {
      alert(response.data.errors[0]);
    }
  };

  const onSubmit = (data: AddFormValue) => {
    const Cost = data.CostName || "";
    const status = data.Status !== undefined ? data.Status : "";

    let id = {
      Id: Id,
    };
    const formData = {
      CostName: Cost,
      Status: status,
    };
    console.log(formData);
    isEdit ? updateCost({ ...formData, ...id }) : addCost(formData);
  };
  return (
    <div className="container-fluid">
      <div className="dashboard-content-wrapper">
        <div className="d-flex justify-content-between">
          <h1 className="page-heading">Cost</h1>
          <div className="settings-add-button ms-4">
            <div className="secondary-button" onClick={() => openDialog()}>
              <AddCircleOutlineIcon></AddCircleOutlineIcon>
              <span className="ps-1">Add Cost</span>
            </div>
          </div>
        </div>
        <div className="location-table">
          <table {...getTableProps}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps} key={index++}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} key={column.id}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={row.index}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}> {cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <ReactModal
        isOpen={addCostDialog}
        className="addtype-modal"
        overlayClassName="overlay"
      >
        <div
          className="horizontal-wrapper-spacebetween"
          style={{ marginBottom: "1rem", zIndex: "20", height: "5%" }}
        >
          <h1 className="page-heading">{dialogTitle}</h1>
          <PageLink
            onClick={() => handleClose()}
            style={{ marginBottom: "1rem" }}
          >
            Cancel
          </PageLink>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex">
            <div className="input-field-div-wrapper w-100 me-4">
              <Label>Cost Name</Label>
              <input
                className="input-field-div"
                placeholder="Cost Name"
                {...register("CostName", { required: "Cost Name is required" })}
                name="CostName"
                id="CostName"
                autoComplete="off"
              />
              <p className="form-error form-error-position">
                {errors.CostName && errors.CostName?.message}
              </p>
            </div>
            <div className="ms-4">
              <select
                style={{ marginTop: "6px" }}
                className="dropdown-control-large"
                {...register("Status", { required: false })}
                name="Status"
                id="Status"
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>
          <div className="w-100 d-flex justify-content-center">
            <div className="submit-button-div">
              <Button type="submit">{isEdit ? "Update" : "Add"}</Button>
            </div>
          </div>
        </form>
      </ReactModal>
    </div>
  );
};
export default Cost;
